
import { FC } from 'react';

interface SwedenFlagProps {
  className?: string;
}

const SwedenFlag: FC<SwedenFlagProps> = ({ className = "w-5 h-4" }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Sweden flag"
    >
      <rect width="20" height="16" fill="#006AA7" />
      <rect x="6" y="0" width="2" height="16" fill="#FECC00" />
      <rect x="0" y="6" width="20" height="2" fill="#FECC00" />
    </svg>
  );
};

export default SwedenFlag;
